import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import QuanLyCongViecApi from "service/QuanLyCongViec/QuanLyCongViecApi";
import { getDate } from "../../../../utils/formatDate";
const statusMap = {
    1: "Đang thực hiện",
    3: "Quá hạn",
    4: "Kết thúc",
};

const evaluationMap = {
    1: { text: "Hoàn thành", className: "text-success" },
    2: { text: "Không hoàn thành", className: "text-danger" },
};

export const ModalChiTiet = ({ show, onHide, item }) => {
    const [taskDetails, setTaskDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (show && item && item.Id) {
            const fetchTaskDetails = async () => {
                setIsLoading(true);
                setTaskDetails(null); 
                try {
                    const res = await QuanLyCongViecApi.getTaskById(item.Id);
                    if (res.status === 200) {
                        setTaskDetails(res.data);
                    }
                } catch (error) {
                    console.error("Lỗi khi tải chi tiết công việc:", error);
                } finally {
                    setIsLoading(false);
                }
            };
            fetchTaskDetails();
        }
    }, [show, item]);

    const renderInfoRow = (label, value) => (
        <div className="form-group row">
            <label className="col-md-3 label-control color7-bold">{label}</label>
            <div className="col-md-9">
                <p className="form-control-static">{value || '---'}</p>
            </div>
        </div>
    );

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="xl" 
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left"
        >
            <Modal.Header>
                <h4 className="modal-title color7-bold">
                    <span className="btn-icon-right">
                        <i className="fa-solid fa-circle-info" style={{ marginRight: '10px' }}></i>
                    </span>
                    Chi tiết công việc
                </h4>
                <button type="button" className="close-popup-new" onClick={onHide}>
                    <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                </button>
            </Modal.Header>

            <Modal.Body>
                {isLoading && <div className="p-5 text-center">Đang tải dữ liệu...</div>}
                {!isLoading && taskDetails && (
                    <div className="form form-horizontal">
                        <div className="form-body">
                            {renderInfoRow("Mã công việc", taskDetails.WorkCode)}
                            {renderInfoRow("Tên công việc", taskDetails.Title)}
                            {renderInfoRow("Liên quan đến hợp đồng", taskDetails.ContractCode)}
                            {renderInfoRow("Nội dung công việc", taskDetails.Content)}
                            {renderInfoRow("Người giao việc", taskDetails.AssignedByName)}
                            {renderInfoRow("Trạng thái", statusMap[taskDetails.StatusCode] || "Không xác định")}                           
                            <hr />
                            <strong className="label-control color7-bold">Lịch sử đánh giá</strong>
                            <div className="custom-table-wrapper mt-2" style={{ maxHeight: 300, overflowY: 'auto' }}>
                                <div className="table-headers d-flex align-items-center">
                                    <div className="custom-table-header" style={{ width: '5%' }}><p>STT</p></div>
                                    <div className="custom-table-header" style={{ width: '15%' }}><p>Thời gian</p></div>
                                    <div className="custom-table-header" style={{ width: '15%' }}><p>Người nhận việc</p></div>
                                    <div className="custom-table-header" style={{ width: '15%' }}><p>Đánh giá</p></div>
                                    <div className="custom-table-header" style={{ width: '25%' }}><p>Lý do không hoàn thành</p></div>
                                    <div className="custom-table-header" style={{ width: '25%' }}><p>Nhận xét</p></div>
                                </div>
                                <div className="custom-table-body">
                                    {taskDetails.EvaluationHistory && taskDetails.EvaluationHistory.length > 0 ? (
                                        taskDetails.EvaluationHistory.map((history, idx) => {
                                            const evaluation = evaluationMap[history.Status] || { text: "N/A", className: "" };
                                            return (
                                                <div className="custom-table-row" key={idx}>
                                                    <div className="custom-table-cell" style={{ width: '5%' }}><p>{idx + 1}</p></div>
                                                    <div className="custom-table-cell" style={{ width: '15%' }}><p>{getDate(taskDetails.StartDate)} <br /> {getDate(taskDetails.EndDate)}</p></div>
                                                    <div className="custom-table-cell" style={{ width: '15%' }}><p>{taskDetails.AssignedToName}</p></div>
                                                    <div className="custom-table-cell" style={{ width: '15%' }}><p className={evaluation.className}><strong>{evaluation.text}</strong></p></div>
                                                    <div className="custom-table-cell" style={{ width: '25%' }}><p>{history.Reason || '---'}</p></div>
                                                    <div className="custom-table-cell" style={{ width: '25%' }}><p>{history.Comment || '---'}</p></div>
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <div className="custom-table-row">
                                            <p style={{ textAlign: 'center', width: '100%', padding: '15px 0' }}>Không có lịch sử đánh giá</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-new-main btn-closenew" onClick={onHide}>
                    <span><i className="mdi mdi-close"></i></span>&nbsp; Đóng
                </button>
            </Modal.Footer>
        </Modal>
    );
};